import popoverStyle from '@salesforce/retail-react-app/app/theme/components/base/popover'

export default {
    ...popoverStyle,
    baseStyle: {
        popper: {
            ...popoverStyle.baseStyle.popper,
            boxShadow: 'unset',
        },
    },
}
